const viewport = require('./viewport');

const hiddenClass = 'site-nav__mobile--hidden';
const openClass = 'site-nav__toggle--open';

let $nav = document.getElementById('site-nav');
let visible = false;

$nav = {
	root: $nav,
	toggle: document.getElementById('site-nav__toggle'),
	products: document.getElementById('site-nav__products'),
	company: document.getElementById('site-nav__company'),
	mobile: false
};

const nav = {
	create: () => {

		$nav.mobile = document.createElement('div');
		$nav.mobile.classList.add('site-nav__mobile', hiddenClass);
		document.body.insertBefore($nav.mobile, $nav.root);
		document.body.insertBefore($nav.root, $nav.mobile);

		// Add the nav items
		$nav.mobile.appendChild($nav.products);
		$nav.mobile.appendChild($nav.company);

		viewport.addListener('nav', () => {
			if( viewport.mq('tablet-wide') )
				nav.destroy();
		});

	},
	show: () => {

		// If the mobile nav exists
		if( $nav.mobile ) {

			$nav.mobile.classList.remove(hiddenClass);
			$nav.toggle.classList.add(openClass);

		// Create it, then show again
		}else{
			nav.create();
			setTimeout(nav.show, 10);
		}

	},
	hide: () => {
		$nav.toggle.classList.remove(openClass);
		$nav.mobile.classList.add(hiddenClass);
	},
	destroy: () => {

		// Return the elements to their natural position in the DOM
		$nav.root.insertBefore($nav.products, $nav.root.firstChild);
		$nav.root.appendChild($nav.company);

		// Remove the mobile nav
		$nav.mobile.parentNode.removeChild($nav.mobile);

		// Reset the variable
		$nav.mobile = false;

		// Remove the resize listener
		viewport.removeListener('nav');

		// It's hidden now
		visible = false;

	}
};

$nav.toggle.addEventListener('click', (e) => {
	nav[visible ? 'hide' : 'show']();
	visible = !visible;
	e.preventDefault();
});



// WEBPACK FOOTER //
// ./src/js/modules/nav.js